// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1sxYW","input":"styles_input__2Tm3N","checkboxIcon":"styles_checkboxIcon__1kT_c"};